export enum CardType {
    BIDDER = 'Bidders',
    CUSTOM = 'CUSTOM',
    CUSTOMER = 'Customers',
    FOLLOW_UP = 'My Follow-ups',
    INFO = 'Information',
    INTERNAL = 'Internal',
    INVENTORY = 'Inventory',
    VEHICLE = 'Vehicles',
    PIPELINE = 'Pipeline',
}
